import type { ReactNode } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

type AthleteVisualizationSelectOption = {
  value: string;
  label: ReactNode;
};

export function AthleteVisualizationSelect({
  label,
  value,
  placeholder,
  options,
  onValueChange,
  wrapperClassName,
  triggerClassName,
  contentClassName,
}: {
  label: string;
  value: string;
  placeholder: string;
  options: AthleteVisualizationSelectOption[];
  onValueChange: (value: string) => void;
  wrapperClassName?: string;
  triggerClassName?: string;
  contentClassName?: string;
}) {
  return (
    <div className={cn("athlete-series-select-wrap", wrapperClassName)}>
      <span className="athlete-series-select-label">{label}</span>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger
          className={cn(
            "athlete-viz-select-trigger min-w-[220px] rounded-full text-xs md:max-w-[320px]",
            triggerClassName,
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className={contentClassName}>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
